module.exports = __webpack_public_path__ + "static/media/secure-data.19493939.svg";